import { AlignmentMeasurementDetails } from './AlignmentMeasurementDetails';
import { AlignmentMeasurementOptions } from './AlignmentMeasurementOptions';
import { createAlignmentMeasurementController } from './alignment-measurement-controller';

export const alignmentMeasurementConfig = {
  detailsComponent: AlignmentMeasurementDetails,
  optionsComponent: AlignmentMeasurementOptions,
  createController: createAlignmentMeasurementController,
};

export type {
  AlignmentDetailsProps,
  AlignmentMeasurementController,
  AlignmentMode,
} from './alignment-measurement.types';
export type { AlignmentMeasurementDetailsProps } from './AlignmentMeasurementDetails';
export type { AlignmentMeasurementOptionsProps } from './AlignmentMeasurementOptions';
export {
  AlignmentMeasurementDetails,
  AlignmentMeasurementOptions,
  createAlignmentMeasurementController,
};
